import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Toaster } from "react-hot-toast";
import {configureStore} from "@reduxjs/toolkit";
import { BrowserRouter } from 'react-router-dom';
import rootReducer from './reducer';
import { Provider } from 'react-redux';

const store = configureStore({
  reducer:rootReducer,
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>


    <Provider store = {store}>
    <BrowserRouter>
        <App />
        <Toaster 
          toastOptions={{
            className: 'dark:bg-slate-900 dark:text-slate-400 dark:font-semibold dark:border border-sky-500',
          }}
        />
      </BrowserRouter>
  </Provider>

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
